import { useLayoutEffect } from 'react';
const useViewbox = (ref) => {
    useLayoutEffect(() => {
        if (ref?.current !== null &&
            !ref?.current?.getAttribute('viewBox') &&
            ref?.current?.getBBox &&
            ref?.current?.getBBox().width &&
            ref?.current?.getBBox().height) {
            const box = ref.current.getBBox();
            ref.current.setAttribute('viewBox', [box.x, box.y, box.width, box.height].join(' '));
        }
    });
};
export default useViewbox;
//# sourceMappingURL=useViewbox.js.map